module.exports = __webpack_public_path__ + "img/has-deployed.3a170939.png";